import { hostConfig } from "../config"; // env
import { toast } from "react-toastify";
/** ********************************* Import URL ************************************* */
// import { URL_CONSTANTS } from "./urls";
// import { get } from "lodash";

/** ****************************** Response Handler *********************************** */

const logout = (res: any) => {
  res?.json().then((data: any) => {
    toast.error(
      data?.detail?.message ||
        data?.detail?.session_message ||
        (typeof data?.detail === "string" && data?.detail),
      {
        position: "bottom-center",
        hideProgressBar: true,
        // className: "custom-toast",
      }
    );
    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  });
};

const reLogin = () => {
  toast.error("Session Expired", {
    position: "bottom-center",
    hideProgressBar: true,
    // className: "custom-toast",
  });
  localStorage.clear();
  setTimeout(() => {
    window.location.href = "/";
  }, 2000);
};

const maintenance = () => {
  toast.error("Our System is Down for Maintenance")
  setTimeout(() => {
    window.location.href = "/maintenance";
  }, 2000);
};

const responseStatusHandler = (response: any) => {
  switch (response.status) {
    case 400:
      return response;
    case 422:
      return response;
    case 401:
      return reLogin();
      break;
    case 402:
      return { error: "Payment Required" };
    case 403:
      logout(response);
      return { error: "Forbidden" };
    case 404:
      return { error: "Not Found" };
    case 405:
      return { error: "Method Not Allowed" };
    case 406:
      return { error: "Not Acceptable" };
    case 408:
      return { error: "Request Timeout" };
    case 409:
      return { error: "Request Already Exist" };
    case 410:
      return { error: "permanently deleted from server" };
    case 500:
      return { error: "Internal Server Error" };
    case 501:
      return { error: "Not Implemented" };
    case 502:
      return maintenance();
    case 503:
      return maintenance();
    case 504:
      return { error: " Gateway Timeout" };
    case 511:
      return { error: " Network Authentication Required" };
    case 200:
    case 201:
      return response;
    default:
      return false;
  }
};

/** ****************************** Error Handler *********************************** */
const errorHandler = (error: Error) => error;

const token = localStorage.getItem("accessToken");

// Define the types for the parameters
// type ServiceType = "JSONSERVER" | "API"; // Adjust this based on your actual services

// Define the function
export const postDataApi = async (
  requestUrl: string,
  params: any
): Promise<ResponseType | any> => {
  try {
    const response = await fetch(`${hostConfig.API_URL}${requestUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(params),
    });

    // Log the URL and the data being sent

    const result = responseStatusHandler(response);

    if (
      result.status === 200 ||
      result.status === 201 ||
      result.status === 400 ||
      result.status === 422
    ) {
      return await result.json();
    } else {
      return result;
    }
  } catch (err) {
    if (err instanceof Error) {
      errorHandler(err);
    } else {
      // Handle the case where err is not an instance of Error
      errorHandler(new Error("An unknown error occurred"));
    }
    throw err; // Optionally rethrow the error if you want to handle it further up the call stack
  }
};

/** ****************************** Post FormData Api (File Upload) ******************* */

export const postFormDataApi = async (
  requestUrl: string,
  formData: FormData
): Promise<ResponseType | any> => {
  try {
    const tokenData = localStorage.getItem("accessToken");
    const response = await fetch(`${hostConfig.API_URL}${requestUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${tokenData}`,
        // Don't set Content-Type for FormData - browser will set it with boundary
      },
      body: formData,
    });

    const result = responseStatusHandler(response);

    if (
      result.status === 200 ||
      result.status === 201 ||
      result.status === 400 ||
      result.status === 422
    ) {
      return await result.json();
    } else {
      return result;
    }
  } catch (err) {
    if (err instanceof Error) {
      errorHandler(err);
    } else {
      errorHandler(new Error("An unknown error occurred"));
    }
    throw err;
  }
};

export const getUserCredentials = async (
  requestUrl: string,
  payload: { encode_token: string }
) => {
  try {
    const response = await fetch(`${hostConfig.API_URL}${requestUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload), // Wrap token in an object
    });

    if (!response.ok) {
      // Handle HTTP errors
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json(); // Parse the JSON response
    return data; // Return the parsed data
  } catch (err) {
    if (err instanceof Error) {
      errorHandler(err);
    } else {
      errorHandler(new Error("An unknown error occurred"));
    }
    throw err; // Optionally rethrow the error if further handling is needed
  }
};

// interface ResponseResult {
//   status: number;
//   json: () => Promise<any>;
// }

export const getListByApi = async (
  requestUrl: string,
  params: Record<string, any> = {} // params can be any object
): Promise<any> => {
  let getParams = "?";
  const tokenData = localStorage.getItem("accessToken");
  // Iterate over all keys in the params object and append to the URL
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null) {
      getParams += `${key}=${params[key]}&`;
    }
  });
  
  // Remove the trailing '&' if it exists
  if (getParams.endsWith("&")) {
    getParams = getParams.slice(0, -1);
  }

  if (getParams === "?") {
    getParams = "";
  }

  try {
    const response = await fetch(
      `${hostConfig.API_URL}${requestUrl}${getParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
      }
    );

    const result = await responseStatusHandler(response);

    if (
      result.status === 200 ||
      result.status === 201 ||
      result.status === 400
    ) {
      return await result.json();
    } else {
      return result;
    }
  } catch (err) {
    if (err instanceof Error) {
      errorHandler(err);
    } else {
      errorHandler(new Error("An unknown error occurred"));
    }
    throw err; // Optionally rethrow the error if further handling is needed
  }
};

/** ****************************** Delete by Id Api *********************************** */

export const deleteDataByIdApi = async (
  requestUrl: string,
  dataId: string | number
): Promise<any> => {
  try {
    const response = await fetch(
      `${hostConfig.API_URL}${requestUrl}/${dataId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const handledResponse = await responseStatusHandler(response);

    if ([200, 201, 400].includes(handledResponse.status)) {
      return handledResponse.json();
    }

    return handledResponse;
  } catch (err) {
    if (err instanceof Error) {
      errorHandler(err);
    } else {
      errorHandler(new Error("An unknown error occurred"));
    }
    throw err; // Optionally rethrow the error if further handling is needed
  }
};

export const getDataByIdApi = async (
  requestUrl: string,
  dataId: string | number,
  params?: any
): Promise<any> => {
  let getParams = "?";
  const tokenData = localStorage.getItem("accessToken");
  // Iterate over all keys in the params object and append to the URL
  if (params) {
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null) {
        getParams += `${key}=${params[key]}&`;
      }
    });
  }
  try {
    const response = await fetch(
      `${hostConfig.API_URL}${requestUrl}/${dataId}${getParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
      }
    );

    const handledResponse = await responseStatusHandler(response);

    if ([200, 201, 400].includes(handledResponse.status)) {
      return handledResponse.json();
    }

    return handledResponse;
  } catch (err) {
    if (err instanceof Error) {
      errorHandler(err);
    } else {
      errorHandler(new Error("An unknown error occurred"));
    }
    throw err; // Optionally rethrow the error if further handling is needed
  }
};

export const putDataByIdApi = (requestUrl: string, id: number, params: any) => {
  const token = localStorage.getItem("accessToken");
  return fetch(`${hostConfig.API_URL}${requestUrl}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(params),
  })
    .then((response) => responseStatusHandler(response))
    .then((result) =>
      result.status === 200 || result.status === 201 || result.status === 400
        ? result.json()
        : result
    )
    .catch((error) => {
      errorHandler(error);
    });
};

export const putDataApi = (requestUrl: string, params: any) => {
  const token = localStorage.getItem("accessToken");
  return fetch(`${hostConfig.API_URL}${requestUrl}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(params),
  })
    .then((response) => responseStatusHandler(response))
    .then((result) =>
      result.status === 200 || result.status === 201 || result.status === 400
        ? result.json()
        : result
    )
    .catch((error) => {
      errorHandler(error);
    });
};

export const deleteMultipleDataApi = async (
  requestUrl: string,
  params: any
): Promise<ResponseType | any> => {
  try {
    const response = await fetch(`${hostConfig.API_URL}${requestUrl}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(params),
    });

    // Log the URL and the data being sent

    const result = responseStatusHandler(response);

    if (
      result.status === 200 ||
      result.status === 201 ||
      result.status === 400 ||
      result.status === 422
    ) {
      return await result.json();
    } else {
      return result;
    }
  } catch (err) {
    if (err instanceof Error) {
      errorHandler(err);
    } else {
      // Handle the case where err is not an instance of Error
      errorHandler(new Error("An unknown error occurred"));
    }
    throw err; // Optionally rethrow the error if you want to handle it further up the call stack
  }
};
